import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { isDevMode } from "@/shared/lib/config";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { QueryState } from "@/shared/ui/QueryState";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon, HelpCircleIcon } from "lucide-react";
import {
  useShippingSettingsQuery,
  useUpdateShippingSettings,
  useZonesQuery,
} from "../api/queries";
import { ShippingSettingsFormTour, useShippingSettingsFormTour } from "../tour";
import { ShippingSettingsForm } from "../ui/ShippingSettingsForm";

export function ShippingSettingsPage() {
  const nav = useNavigate({ from: "/app/shipping/settings" });
  const { data: settings, ...settingsResult } = useShippingSettingsQuery();
  const zonesQuery = useZonesQuery();
  const zones = zonesQuery.data ?? [];
  const updateSettings = useUpdateShippingSettings();
  const { run, handleJoyrideCallback, startTour } =
    useShippingSettingsFormTour();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຕັ້ງຄ່າຄ່າສົ່ງ" },
          ]}
        />
      </Header>
      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ຕັ້ງຄ່າຄ່າສົ່ງ{" "}
              <Button
                variant="ghost"
                size="icon"
                onClick={startTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            </h2>
            <p className="text-muted-foreground">
              ໂຊນເລີ່ມຕົ້ນ ແລະ ນ້ຳໜັກ variant ເລີ່ມຕົ້ນ (ກຣາມ).
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/shipping/zones" } as any)}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>
        <QueryState
          result={settingsResult}
          title="ກຳລັງໂຫຼດຕັ້ງຄ່າ"
          description="ກຳລັງດຶງລາຍລະອຽດ"
          variant="fullscreen"
        >
          {!settings ? null : (
            <div className="mt-6 rounded-xl border bg-card p-6">
              <ShippingSettingsForm
                zones={zones}
                initialValues={{
                  defaultZoneId: settings.defaultZoneId ?? null,
                  defaultVariantWeightGrams: settings.defaultVariantWeightGrams,
                }}
                onSubmit={async (values) => {
                  await updateSettings.mutateAsync(values);
                }}
                onCancel={() => nav({ to: "/app/shipping/zones" } as any)}
                submitting={updateSettings.isPending}
                onDevFill={isDevMode ? () => {} : undefined}
              />
            </div>
          )}
        </QueryState>
        <ShippingSettingsFormTour
          run={run}
          onCallback={handleJoyrideCallback}
        />
      </Main>
    </>
  );
}
